import * as ng from 'angular';
import { IFacturesXService, IFacturesXStatus } from '../factures-x.types';

export default class FacturesXProgressModalController {
	public resolve: { factureIds: number[] };
	public modalInstance: ng.ui.bootstrap.IModalInstanceService;

	public factureIds: number[] = [];
	public status: IFacturesXStatus = { total: 0, enCours: 0, generees: 0, enErreur: 0 };
	public isDone = false;

	private pollPromise: ng.IPromise<unknown> | null = null;
	private isPolling = false;

	/* @ngInject */
	constructor(
		private readonly $interval: ng.IIntervalService,
		private readonly FacturesXService: IFacturesXService
	) {}

	public $onInit(): void {
		this.factureIds = this.resolve.factureIds;
		this.status.total = this.factureIds.length;
		this.status.enCours = this.factureIds.length;

		// Interrogation périodique de l'état de génération.
		// $interval s'exécute dans le digest Angular et est annulé dans $onDestroy.
		this.pollPromise = this.$interval(() => this.poll(), 2000);
	}

	public $onDestroy(): void {
		this.stopPolling();
	}

	private stopPolling(): void {
		if (this.pollPromise) {
			this.$interval.cancel(this.pollPromise);
			this.pollPromise = null;
		}
	}

	private async poll(): Promise<void> {
		// Évite les appels concurrents si une requête dépasse l'intervalle.
		if (this.isPolling) return;
		this.isPolling = true;
		try {
			const status = await this.FacturesXService.getFacturesXStatus(this.factureIds);
			this.status = status;
			if (status.enCours === 0) {
				this.isDone = true;
				this.stopPolling();
			}
		} catch {
			// ignore polling errors
		} finally {
			this.isPolling = false;
		}
	}

	public get progressGenerees(): number {
		if (!this.status.total) return 0;
		return (this.status.generees / this.status.total) * 100;
	}

	public get progressEnErreur(): number {
		if (!this.status.total) return 0;
		return (this.status.enErreur / this.status.total) * 100;
	}

	public close(): void {
		this.modalInstance.close();
	}
}
